const ICON_BACK_ACTION = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.1}
      d="M3.996 8.37.55 5l3.446-3.37"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={1.1}
      d="M9.45 5H.55"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default ICON_BACK_ACTION;
